import dayjs from 'dayjs'
import jingbeian from '@/assets/jingbeian.png'
// 静态资源
export const copyright = `<div style="display: flex;justify-content: center;color:rgba(0, 0, 0, 0.25);">
<span style="float:left;">Copyright ©-${dayjs().year()} 北京华来荣信息技术有限公司</span>
<span style="padding:0 15px;float:left;">
  <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502046223" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;margin-top:0;border:0;"><img src="${jingbeian}" style="float:left;width:15px;margin-top:2px;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:rgba(0, 0, 0, 0.25);">京公网安备 11010502046223号</p></a>
</span>
<span style="float:left;">京ICP备14042096号-1</span>
</div>`
// 请输入必填项
export const promptInput = 'Please enter the required field'
// 请选择必填项
export const promptSelect = 'Please select the required field'
// 填写信息有误
export const Incorrect =
  'Fill in the information incorrectly or incompletely, please re-fill'
// 编辑成功
export const editSuccess = 'Successfully modified'
// 添加评论
export const addCommentSuc = 'You successfully added comments'
// 上传成功
export const uploadSuc = 'Successfully upload'
// 提交成功
export const subSuc = 'Successfully submit'
// 设置成功
export const setSuc = 'Successfully set'
//  反馈成功
export const feedbackSuc = 'Successful feedback'
// 星期天
export const week = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
]
// Module
export const moduleMap = [
  {
    value: 'MODULE_1',
    title: 'Module 1 - Kick Off'
  },
  {
    value: 'MODULE_2',
    title: 'Module 2 - PS Brainstorm'
  },
  {
    value: 'MODULE_3',
    title: 'Module 3 - Essay Brainstorm'
  },
  {
    value: 'MODULE_4',
    title: 'Module 4'
  },
  {
    value: 'MODULE_5',
    title: 'Module 5'
  },
  {
    value: 'MODULE_6',
    title: 'Module 6'
  },
  {
    value: 'MODULE_7',
    title: 'Module 7 - SM CS'
  },
  {
    value: 'MODULE_8',
    title: 'Module 8 - CM CS'
  },
  {
    value: 'INTERVIEW',
    title: 'Mock Interview'
  },
  {
    value: 'MODULE_20',
    title: 'Module 0'
  }
]
// 消息类型
export const messageTypeMap = [
  {
    value: 'DETAIL_INFO',
    title: 'Detail info'
  },
  {
    value: 'CHANGEPWD',
    title: 'Change password'
  },
  {
    value: 'CV',
    title: 'CV'
  },
  {
    value: 'RL',
    title: 'RL'
  },
  {
    value: 'APPOINTMENT',
    title: 'Appointment'
  },
  {
    value: 'INTERVIEW_APPOINTMENT',
    title: 'Program-Interview'
  },
  {
    value: 'ESSAY',
    title: 'Program-Essay'
  },
  {
    value: 'CONTACT_US',
    title: 'Contact us'
  },
  {
    value: 'TEAM',
    title: 'Mentee'
  }
]
// grade年级
export const gradeMap = [
  {
    value: 'FRESHMAN',
    title: 'Freshman'
  },
  {
    value: 'SOPHOMORE',
    title: 'Sophomore'
  },
  {
    value: 'JUNIOR',
    title: 'Junior'
  },
  {
    value: 'SENIOR',
    title: 'Senior'
  },
  {
    value: 'GRADSCHOOL_1',
    title: '1st year of grad school'
  },
  {
    value: 'GRADSCHOOL_2',
    title: '2nd year of grad school'
  },
  {
    value: 'OTHER',
    title: 'Other'
  }
]
// 推荐状态
export const referralStatusMap = [
  {
    value: 'ONGOING',
    title: 'Pending'
  },
  {
    value: 'SUCCESS_RECOMMEND',
    title: 'Successful entry'
  },
  {
    value: 'SUCCESS_RECOMMEND_SCHOLAR',
    title: 'Successful nomination'
  },
  {
    value: 'FAIL_RECOMMEND',
    title: 'Failed'
  },
  {
    value: 'FAIL_RECOMMEND_SCHOLAR',
    title: 'Failed'
  },
  {
    value: 'SUCCESS_SIGN',
    title: 'Signed'
  },
  {
    value: 'FAIL_SIGN',
    title: 'Not Signed'
  }
]
// 问题类型
export const questionTypeMap = [
  {
    value: 'EASSYEDITING',
    title: 'Essay Editing'
  },
  {
    value: 'TIMECLAIM',
    title: 'Time Claim'
  },
  {
    value: 'TECHNICALPROBLEM',
    title: 'Technical Problem'
  },
  {
    value: 'SYSTEMOPERATIONS',
    title: 'System Operation'
  },
  {
    value: 'ZOOMAPPOINTMENTS',
    title: 'Zoom appointments'
  },
  {
    value: 'FILEUPLOADS',
    title: 'File uploads'
  },
  {
    value: 'PAYMENT',
    title: 'Timesheets/Payments/Rates'
  },
  {
    value: 'TURNAROUNDTIMES',
    title: 'Turnaround times'
  },
  {
    value: 'PACKAGEDETAILS',
    title: 'Mentee service package details'
  },
  {
    value: 'SPECIFICMODULE',
    title: 'Specific module details'
  },
  {
    value: 'OTHER',
    title: 'Other'
  }
]
//
export const applyLevelMap = new Map([
  ['MASTER', 'Master'],
  ['PHD', 'PhD'],
  ['BOTH', 'Both'],
  ['UNKNOW', 'Unknow']
])

export const capacityList = [
  {
    value: '1',
    label: '1 mentee'
  },
  {
    value: '2',
    label: '2 mentee'
  },
  {
    value: '3',
    label: '3 mentee'
  },
  {
    value: 'more',
    label: 'More than 3 mentees',
    children: [
      {
        value: '4',
        label: '4 mentee'
      },
      {
        value: '5',
        label: '5 mentee'
      },
      {
        value: '6',
        label: '6 mentee'
      },
      {
        value: '7',
        label: '7 mentee'
      },
      {
        value: '8',
        label: '8 mentee'
      },
      {
        value: '9',
        label: '9 mentee'
      },
      {
        value: '10',
        label: '10 mentee'
      }
    ]
  }
]
